import { useRef, useState } from "react";

// The popover of a checklist row (note / photo), the dialog to edit the note + photo of that row,
// and the hidden uploader that takes the photo of a row.
const useEditorNote = ({ permittedToEdit, saveDetilMany }) => {
  const overlayRef = useRef(null);

  const [popoverPengecekanData, setPopoverPengecekanData] = useState({});
  const [showEditDeskripsiTambahanDialog, setShowEditDeskripsiTambahanDialog] =
    useState(false);
  // the hidden photo uploader (EditorFotoUploader) and the photo it is taking: { row }
  const fotoUploaderRef = useRef(null);
  const fotoTargetRef = useRef(null);

  const handleOnClickDeskripsi = (event, row) => {
    if (permittedToEdit) {
      setPopoverPengecekanData({ ...row });
      overlayRef.current.toggle(event);
    }
  };

  const handleOnClickEditNote = (event) => {
    overlayRef.current.toggle(event);
    setShowEditDeskripsiTambahanDialog(true);
  };

  // the note dialog has a note and a gambar. Saved with savemany, so the gambar goes as the url of the file manager.
  const handleOnConfirmEditNote = (row) => {
    setShowEditDeskripsiTambahanDialog(false);

    saveDetilMany({
      pengecekanDetilData: [
        {
          ...row,
          gambar: row.gambar ? row.gambar.split("?serial=")[0] : row.gambar,
        },
      ],
    });
  };

  // "Foto" of the popover: close the popover and press "Take Photo" of the hidden uploader
  const handleOnClickFoto = (event) => {
    overlayRef.current.toggle(event);

    fotoTargetRef.current = { row: popoverPengecekanData };
    const takePhoto = Array.from(
      fotoUploaderRef.current.querySelectorAll("button")
    ).find((button) => /Take Photo/i.test(button.textContent));
    if (takePhoto) takePhoto.click();
  };

  // a photo was taken / cleared: save that row with the new photo
  const handleOnChangeFotoDetil = ({ detil, gambar }) => {
    saveDetilMany({
      pengecekanDetilData: [
        {
          ...detil,
          gambar: gambar ? gambar.split("?serial=")[0] : gambar,
        },
      ],
    });
  };

  return {
    overlayRef,
    popoverPengecekanData,
    setPopoverPengecekanData,
    showEditDeskripsiTambahanDialog,
    setShowEditDeskripsiTambahanDialog,
    handleOnClickDeskripsi,
    handleOnClickEditNote,
    handleOnConfirmEditNote,
    fotoUploaderRef,
    fotoTargetRef,
    handleOnClickFoto,
    handleOnChangeFotoDetil,
  };
};

export default useEditorNote;
